import { useSelector } from "react-redux";
import { DIALER_NAME } from "./dialerReducer";

export const useCallOutcome = (name = DIALER_NAME) => useSelector((state) => state[name].outcome);
export const useCallState = (name = DIALER_NAME) => useSelector((state) => state[name].callState);
export const useIsRecording = (name = DIALER_NAME) => useSelector((state) => state[name].isRecording);
export const useIsRecordingConsentRequired = (name = DIALER_NAME) =>
  useSelector((state) => state[name].isRecordingConsentRequired);
export const useConference = (name = DIALER_NAME) => useSelector((state) => state[name].conference);
export const useError = (name = DIALER_NAME) => useSelector((state) => state[name].error);
export const useLeadUuids = (name = DIALER_NAME) => useSelector((state) => state[name].leadUuids);
export const useConferenceCallLeadUuids = (name = DIALER_NAME) =>
  useSelector((state) => state[name].conferenceCallLeadUuids);
export const useConferenceCallSource = (name = DIALER_NAME) =>
  useSelector((state) => state[name].conferenceCallSource);
export const useLoading = (name = DIALER_NAME) => useSelector((state) => state[name].loading);
export const useComment = (name = DIALER_NAME) => useSelector((state) => state[name].comment);
export const usePerson = (name = DIALER_NAME) => useSelector((state) => state[name].person);
export const usePhoneNumber = (name = DIALER_NAME) => useSelector((state) => state[name].phoneNumber);
export const usePhoneNumbers = (name = DIALER_NAME) => useSelector((state) => state[name].phoneNumbers);
export const useSession = (name = DIALER_NAME) => useSelector((state) => state[name].session);
export const useValidLeads = (name = DIALER_NAME) => useSelector((state) => state[name].validLeads);
